var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.599609,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F0F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53409 10.5087V6.92915H5.5L4.375 7.65359V6.64364L5.58097 5.87234H6.61222V10.5087H5.53409ZM5.53729 14.5996L11.5373 5.87234H12.6069L6.60689 14.5996H5.53729ZM11.2049 14.5996V13.8155L13.0714 12.3283C13.2958 12.1465 13.4719 11.986 13.5998 11.8468C13.7276 11.7047 13.7915 11.5471 13.7915 11.3738C13.7915 11.1806 13.712 11.03 13.5529 10.9221C13.3967 10.8113 13.2035 10.7559 12.9734 10.7559C12.7376 10.7559 12.543 10.8155 12.3896 10.9348C12.239 11.0513 12.1637 11.2161 12.1637 11.4292H11.1282C11.1282 10.9604 11.3015 10.5882 11.6481 10.3127C11.9975 10.0343 12.4464 9.89506 12.9947 9.89506C13.5515 9.89506 13.9947 10.0371 14.3242 10.3212C14.6566 10.6025 14.8228 10.9476 14.8228 11.3567C14.8228 11.5755 14.7773 11.7786 14.6864 11.9661C14.5984 12.1507 14.4592 12.3354 14.2688 12.5201C14.0785 12.7019 13.8342 12.8979 13.5359 13.1081L12.7731 13.6706V13.7132H14.9123V14.5996H11.2049Z",
    fill: "#163DA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfDay);
export default __webpack_public_path__ + "static/media/half-day.0b7ef0805269c21eb438dc8333418b18.svg";
export { ForwardRef as ReactComponent };